import React from "react";
import EligibilityCheckbox from "../EligibilityCheckbox/EligibilityCheckbox"
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';

const theme = createMuiTheme({
    overrides: {
        MuiTypography: {
            body1: {
                fontFamily: "Avenir, sans-serif",
                fontSize: "12px",
                color: "#333333"
            },
            caption: {
                display: 'block',
                fontFamily: "Avenir, sans-serif",
                fontSize: "12px",
                color: "#333333",
                margin: 0,
                padding: 0
            },
        },
        MuiSvgIcon: {
            root: {
                fontSize: "2.1rem",
            }
        },
        MuiCheckbox: {
            root: {
                "&$checked": {
                    "& svg": {
                        fill: "#DA3732",
                    },
                },
            },
        },
        MuiFormControlLabel: {
            root: {
                display: 'flex',
            },
        },
    }
});

export default function EligibilityInputCheckbox(props) {
    const { value, question, handlerInputCheckboxChange } = props;
    const { checkboxQuestion } = question.field;
    const { innerCheckboxQuestion } = question.field.checkboxQuestion;

    const initialCheckboxValue = value ? value[checkboxQuestion.id] : false;
    const initialInnerCheckboxValue = value ? value[innerCheckboxQuestion.id] : false;

    let checkboxAnswersValues = {};

    const handlerCheckbox = (checkboxCheckedValue) => {
        checkboxAnswersValues = !innerCheckboxQuestion
            ? { [checkboxQuestion.id]: checkboxCheckedValue }
            : {
                [checkboxQuestion.id]: checkboxCheckedValue,
                [innerCheckboxQuestion.id]: false
            }
        handlerInputCheckboxChange(checkboxAnswersValues);
    }

    const handlerInnerCheckbox = (innerCheckboxCheckedValue) => {
        checkboxAnswersValues = {
            [checkboxQuestion.id]: initialCheckboxValue,
            [innerCheckboxQuestion.id]: innerCheckboxCheckedValue
        };
        handlerInputCheckboxChange(checkboxAnswersValues);
    }

    return (
        <ThemeProvider theme={theme}>
            <Typography variant="caption">{checkboxQuestion.title}</Typography>
            <EligibilityCheckbox
                question={question}
                label={checkboxQuestion.label}
                checked={initialCheckboxValue}
                required={checkboxQuestion.required || false}
                handlerCheckboxChange={handlerCheckbox}
            />
            {!initialCheckboxValue
                ? null
                : !innerCheckboxQuestion
                    ? null
                    : <React.Fragment>
                        <Typography variant="caption">{innerCheckboxQuestion.title}</Typography>
                        <EligibilityCheckbox
                            question={question}
                            label={innerCheckboxQuestion.label}
                            checked={initialInnerCheckboxValue}
                            required={innerCheckboxQuestion.required || false}
                            handlerCheckboxChange={handlerInnerCheckbox}
                        />
                    </React.Fragment>
            }
        </ThemeProvider>
    );
}
